import React, {Fragment, FunctionComponent} from "react"
import {BrandList} from "@App/Components/Vehicletree/BrandList"
import {useDispatch} from "react-redux"
import {actionCreators} from '@App/state'
import {Brand} from "@App/types"
import {useTranslation} from "react-i18next"
import {bindActionCreators} from "@reduxjs/toolkit"
import {FunnelHeader} from "@App/Components/Funnel/FunnelHeader";

export type BrandsProps = {
    headline: string
    step: number
    maxSteps: number
    onKeyNumberLinkClick?: () => void
    onSubmit?: (brand: Brand) => void
}

export const Brands: FunctionComponent<BrandsProps> = ({
                                                           headline,
                                                           onKeyNumberLinkClick,
                                                           step,
                                                           maxSteps,
                                                           onSubmit
                                                       }: BrandsProps) => {
    const {t} = useTranslation()

    const dispatch = useDispatch();
    const {chooseBrand, changeBrandFilter} = bindActionCreators(actionCreators, dispatch)

    const setBrand = (brand: Brand): void => {
        chooseBrand(brand)
        changeBrandFilter(brand)
        onSubmit && onSubmit(brand)
    }

    return (
        <Fragment>
            <div className="
                    container bg-white
                    pt-10 pb-12
                ">
                <FunnelHeader heading={headline} step={step} maxSteps={maxSteps} subheading={t('brand.headline')}/>
                <div className="text-sm text-neutral-700 mb-8">
                    {onKeyNumberLinkClick && (
                        <i>{t('brand.skip-steps')} <span
                            className={"font-bold cursor-pointer underline text-primary"}
                            onClick={onKeyNumberLinkClick}>{t('brand.vehicle-registration')}</span>.</i>
                    )}
                </div>
                <BrandList onClick={setBrand}/>
            </div>
        </Fragment>
    );
}
